<template>
	<div>
		<navTitle><div class="pageTitle">专家风采</div></navTitle>
		<div class="memberBox">
			<div class="avatar flex flex-align-center flex-jus-center"><img :src="detail.avatar" class="avatar-inner" /></div>
			<div class="name">{{detail.truename}}</div>
			<div class="tips">{{detail.introduce}}</div>
		</div>
		<div class="info">
			<div class="title">专家简介</div>
			<div class="content" v-html="detail.brief"></div>
			
			<div v-if="videoList.length > 0" class="title" style="margin-top: 20px;">作品赏析</div>
			<div class="videoList flex flex-align-center flex-jus-between flex-wrap">
				<div class="videoItem" v-for="item in videoList" :key="item.id">
					<videoItem :cover="item.pic" :width="167" :height="111" :is_link="item.is_link" :id="item.id" :videoSrc="item.video" :content="item.title"></videoItem>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import videoItem from '@/views/components/videoItem.vue';
/* eslint-disable */
export default {
	components: {
		videoItem
	},
	data() {
		return {
			page: 1,
			detail: {},
			videoList: []
		};
	},
	created() {
		this.getData()
		this.getVideo()
	},
	mounted() {
		
	},
	methods: {
		getData() {
			this.$get('api/expertUser/getExpertUserDetails', {
				expert_user_id: this.$route.query.id
			}).then(res => {
				this.detail = res.data
				this.$wx.ready(() => {
					this.$wx.updateAppMessageShareData({
						title: '福建省民族管弦乐学会',
						desc: '专家风采 ' + this.detail.truename,
						link: location.href,
						imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
					})
					this.$wx.updateTimelineShareData({
						title: '福建省民族管弦乐学会',
						link: location.href,
						imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
					})
				});
			})
		},
		getVideo() {
			this.$get('api/expertUser/getExpertUserVideo', {
				expert_user_id: this.$route.query.id,
				pageSize: 10,
				page: this.page
			}).then(res => {
				this.videoList.splice((this.page - 1)*10, 10, ...res.data)
			})
		},
		toHref(url) {
			location.href = url
		}
	}
};
</script>
<style scoped>
	.content >>> img {
		max-width: 100%;
		height: auto;
	}
</style>
<style scoped lang="stylus">
.memberBox
	width 100%
	height 300px
	background-image url('~@/static/images/index/memberDetailsBG.png')
	background-size 100% 100%
	background-position center
	padding 106px 54px 72px 54px
	margin-top 100px
	position relative
	.name
		width 100%
		text-align center
		font-size 32px
		font-weight bold
		color #000000
	.tips
		margin-top 12px
		width 100%
		text-align center
		font-size 24px
		color #C1986B
	.avatar
		position absolute
		width 172px
		height 172px
		left calc(50% - 86px)
		top -76px
		background-image url('~@/static/images/my/avatarBG2.png')
		background-size 100% 100%
		background-position center
		.avatar-inner
			width 132px
			height 132px
			border-radius 50%
			object-fit cover
.title
	width 100%
	background-image url('~@/static/images/my/apply-circle.png')
	background-position left top
	background-size 38px 46px
	background-repeat no-repeat
	padding-left 16px
	padding-top 6px
	font-size 32px
	font-weight bold
	color #000000
	margin-bottom 28px
.info
	padding 0 30px
	.content
		margin-top 28px
		font-size 26px
		color #333333
</style>
